// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"zS3skVeV","isActive":"vSiEvkkf"};